import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FormReferenceDataService } from '../forms/form-reference-data.service';

@Injectable()
export class FormReferenceDataResolver implements Resolve<any> {
    constructor(private formReferenceDataService: FormReferenceDataService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.formReferenceDataService.load();
        return true;
    }
}
